import request from '@/require/axios.js'
// const qs = require('qs')

export const api = {
  async get (url, data) {
    try {
      let res = await request.get(url, {
        params: data
      })
      res = res.data
      return new Promise((resolve) => {
        if (res.code === 0) {
          resolve(res)
        } else {
          resolve(res)
        }
      })
    } catch (err) {
      // alert('服务器出错')
      console.log(err)
    }
  },
  async post (url, data) {
    try {
      let res = await request.post(url, data)
      res = res.data
      return new Promise((resolve, reject) => {
        if (res.code === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
    } catch (err) {
      // return (e.message)
      // alert('服务器出错')
      console.log(err)
    }
  }
}
// export const GISgetTree = () => {
//   return request({
//     method: 'GET',
//     url: '/politicalDbController/getIndicatorTree'
//   }).then(res => res.data)
// }

// export const GISgetYears = (data) => {
//   return request({
//     method: 'GET',
//     url: '/politicalDbController/getYearsByIndicator',
//     data
//   }).then(res => res.data)
// }
